var _polygon, _path, _circle, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle2, _circle3, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductToMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "55 8 53 7 51 8 51 1 43 1 43 21 63 21 63 1 55 1 55 8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60,50.5H53a3,3,0,0,0-3,3V63H63V53.5A3,3,0,0,0,60,50.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 47.25,
    r: 3.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12H36.586l-1.293,1.293,1.414,1.414,3-3a1,1,0,0,0,0-1.414l-3-3L35.293,8.707,36.586,10H22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.707,50.293l-1.414,1.414L43.586,53H36v2h7.586l-1.293,1.293,1.414,1.414,3-3a1,1,0,0,0,0-1.414Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.293,22.283,26,36.577v-1.82H24V39a1,1,0,0,0,1,1h4.243V38H27.405l14.3-14.3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.178,
    y: 14.075,
    width: 2,
    height: 2.001,
    transform: "translate(-7.244 3.729) rotate(-30.666)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.686,
    y: 5.212,
    width: 2,
    height: 2,
    transform: "translate(-4.04 5.453) rotate(-60.181)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.822,
    y: 14.075,
    width: 2.001,
    height: 2,
    transform: "translate(-4.725 21.854) rotate(-59.329)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.314,
    y: 5.212,
    width: 2,
    height: 2,
    transform: "translate(-0.797 9.431) rotate(-29.815)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 46.5,
    width: 3,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 54.5,
    width: 3,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 50.5,
    width: 4,
    height: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 60.5,
    r: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 60.5,
    r: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7,60.5H9a3.5,3.5,0,0,1,7,0h7v-17H7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24,46.5v14h1a3.5,3.5,0,0,1,7,0h1v-9l-4-5Zm2,5v-3h2.5l2.5,3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.667,10.333a5.317,5.317,0,0,0,1.262,3.443A8.717,8.717,0,0,1,7.314,16h5.31a6.075,6.075,0,0,1,1.24-1.993,5.334,5.334,0,1,0-9.2-3.674Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10,21a2.133,2.133,0,0,0,2.133-2.133v-.192c0-.225.011-.451.031-.675H7.833c.021.212.034.425.034.641v.226A2.133,2.133,0,0,0,10,21Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductToMarket);
export default __webpack_public_path__ + "static/media/product-to-market.0cbef3bd91e9f4c6ba8121495ef5114c.svg";
export { ForwardRef as ReactComponent };